import {takeLatest, put, all, call} from 'redux-saga/effects';
import {successToast} from '../actions';
import * as AC from '../actions/actionTypes';
import {
  addEntranceApi,
  deleteEntranceApi,
  editEntranceApi,
  getEntranceByIdApi,
  getEntrancesApi,
  getEntrancesByBuildingApi,
} from '../api/entrances.service';
import history from '../routes/history';
import {errorHandler} from '../utils/errorHandler';

function* getEntrancesSaga(fn) {
  try {
    const response = yield call(getEntrancesApi, fn.filters);
    yield put({
      type: AC.GET_ENTRANCES_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (error) {
    yield errorHandler(error, AC.GET_ENTRANCES_FAILED);
  }
}

function* getBuildingEntrancesSaga(fn) {
  try {
    const response = yield call(
      getEntrancesByBuildingApi,
      fn.buildingId,
      fn.filters,
    );
    yield put({
      type: AC.GET_BUILDING_ENTRANCES_SUCCEED,
      payload: response.data.data,
      page: response.data.page,
      totalPages: response.data.totalPages,
    });
  } catch (e) {
    yield errorHandler(e, AC.GET_BUILDING_ENTRANCES_FAILED);
  }
}

function* getEntranceDetailsSaga(fn) {
  try {
    const response = yield call(getEntranceByIdApi, fn.id);
    yield put({type: AC.GET_ENTRANCE_DETAILS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_ENTRANCE_DETAILS_FAILED);
  }
}

function* addEntranceSaga(fn) {
  try {
    const response = yield call(addEntranceApi, fn.payload);
    yield put({
      type: AC.ADD_ENTRANCE_SUCCEED,
      payload: response.data,
      buildingId: response.data.buildingId,
      filters: {},
    });
    yield put(successToast('Entrance created successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.ADD_ENTRANCE_FAILED);
  }
}

function* editEntranceSaga(fn) {
  try {
    const response = yield call(editEntranceApi, fn.payload);
    yield put({type: AC.EDIT_ENTRANCE_SUCCEED, payload: response.data});
    yield put(successToast('Entrance edited successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.EDIT_ENTRANCE_FAILED);
  }
}

function* deleteEntranceSaga(fn) {
  try {
    const response = yield call(deleteEntranceApi, fn.id);
    yield put({type: AC.DELETE_ENTRANCE_SUCCEED, payload: response.data});
    yield put(successToast('Entrance deleted successfully!'));
    history.back();
  } catch (e) {
    yield errorHandler(e, AC.DELETE_CUSTOMER_FAILED);
  }
}

function* actionWatcher() {
  yield takeLatest(
    [
      AC.GET_ENTRANCES_REQUEST,
      AC.ADD_ENTRANCE_SUCCEED,
      AC.EDIT_ENTRANCE_SUCCEED,
    ],
    getEntrancesSaga,
  );
  yield takeLatest(
    [AC.GET_BUILDING_ENTRANCES_REQUEST, AC.ADD_ENTRANCE_SUCCEED],
    getBuildingEntrancesSaga,
  );
  yield takeLatest(
    [AC.GET_ENTRANCE_DETAILS_REQUEST, AC.EDIT_ENTRANCE_SUCCEED],
    getEntranceDetailsSaga,
  );
  yield takeLatest(AC.ADD_ENTRANCE_REQUEST, addEntranceSaga);
  yield takeLatest(AC.EDIT_ENTRANCE_REQUEST, editEntranceSaga);
  yield takeLatest(AC.DELETE_ENTRANCE_REQUEST, deleteEntranceSaga);
}

export default function* entrancesSaga() {
  yield all([actionWatcher()]);
}
